import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6478b757")

_pushScopeId("data-v-6478b757")
const _hoisted_1 = {
  class: "container",
  id: "order-actions"
}
const _hoisted_2 = { class: "actions-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-action-confirm fs-26" })
], -1)
const _hoisted_4 = { class: "action-text" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-action-onrequest fs-26" })
], -1)
const _hoisted_6 = { class: "action-text" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-action-cancel fs-26" })
], -1)
const _hoisted_8 = { class: "action-text" }
const _hoisted_9 = { class: "actions-row" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-action-newinvoice fs-26" })
], -1)
const _hoisted_11 = { class: "action-text" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-action-newreciept fs-26" })
], -1)
const _hoisted_13 = { class: "action-text" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-chat fs-26" })
], -1)
const _hoisted_15 = { class: "action-text" }
const _hoisted_16 = { class: "actions-row" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-action-newreciept fs-26" })
], -1)
const _hoisted_18 = { class: "action-text" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-action-newinvoice fs-26" })
], -1)
const _hoisted_20 = { class: "action-text" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-action-newinvoice fs-26" })
], -1)
const _hoisted_22 = { class: "action-text" }
const _hoisted_23 = { class: "actions-row" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-action-newinvoice fs-26" })
], -1)
const _hoisted_25 = { class: "action-text" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-action-newinvoice fs-26" })
], -1)
const _hoisted_27 = { class: "action-text cuted-cell-three-lines" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-action-newinvoice fs-26" })
], -1)
const _hoisted_29 = { class: "action-text" }
const _hoisted_30 = { class: "actions-row" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-action-alldoc fs-26" })
], -1)
const _hoisted_32 = { class: "action-text" }
const _hoisted_33 = { class: "actions-row" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-employee fs-26" })
], -1)
const _hoisted_35 = { class: "action-text" }
const _hoisted_36 = { class: "actions-row text-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_SlotEmployeesModal = _resolveComponent("SlotEmployeesModal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "action-btn with-word-spacing action-green",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeStatus(1)))
      }, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('orderActions.confirm')), 1)
      ]),
      _createVNode("div", {
        class: "action-btn with-word-spacing action-red",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeStatus(2)))
      }, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('orderActions.onRequest')), 1)
      ]),
      _createVNode("div", {
        class: "action-btn with-word-spacing action-black",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeStatus(3)))
      }, [
        _hoisted_7,
        _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('orderActions.cancelOrder')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", {
        class: "action-btn with-word-spacing action-blue",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToETicket && _ctx.goToETicket(...args)))
      }, [
        _hoisted_10,
        _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('orderActions.showETicket')), 1)
      ]),
      _createVNode("div", {
        class: "action-btn with-word-spacing action-blue",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.createSummary && _ctx.createSummary(...args)))
      }, [
        _hoisted_12,
        _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('orderActions.createSummary')), 1)
      ]),
      _createVNode("div", {
        class: "action-btn with-word-spacing action-blue",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.getLink && _ctx.getLink(...args)))
      }, [
        _hoisted_14,
        _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('orderActions.getLink')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode("div", {
        class: "action-btn with-word-spacing action-blue",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.createReceipt()))
      }, [
        _hoisted_17,
        _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('orderActions.newReciept')), 1)
      ]),
      _createVNode(_component_router_link, {
        class: "action-btn with-word-spacing action-blue",
        to: { name: 'invoiceReceiptNew', params: { orderId: _ctx.props.id } }
      }, {
        default: _withId(() => [
          _hoisted_19,
          _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('orderActions.newInvoiceReceipt')), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode("div", {
        class: "action-btn with-word-spacing action-blue",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.createInvoice()))
      }, [
        _hoisted_21,
        _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('orderActions.newInvoice')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_23, [
      _createVNode("div", {
        class: "action-btn with-word-spacing action-blue",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.createCreditInvoice && _ctx.createCreditInvoice(...args)))
      }, [
        _hoisted_24,
        _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('orderActions.newCreditInvoice')), 1)
      ]),
      _createVNode("div", {
        class: "action-btn with-word-spacing action-blue",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.createPerfomaInvoice && _ctx.createPerfomaInvoice(...args)))
      }, [
        _hoisted_26,
        _createVNode("div", _hoisted_27, _toDisplayString(_ctx.perfomaInvoiceTitle), 1)
      ]),
      _createVNode("div", {
        class: "action-btn with-word-spacing action-blue",
        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.clickContractFormAction && _ctx.clickContractFormAction(...args)))
      }, [
        _hoisted_28,
        _createVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('orderActions.contractForm.title')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_30, [
      _createVNode("div", {
        class: "action-btn action-navy-blue",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goAllDoc()))
      }, [
        _hoisted_31,
        _createVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('orderActions.allDoc')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_33, [
      (_ctx.canAssignEmployees)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "action-btn with-word-spacing action-blue",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.orderAssignEmployees && _ctx.orderAssignEmployees(...args)))
          }, [
            _hoisted_34,
            _createVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('button.assign-employees')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_36, [
      _createVNode("div", {
        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args))),
        class: "action-btn-back"
      }, _toDisplayString(_ctx.$t('button.close')), 1)
    ]),
    _createVNode(_component_SlotEmployeesModal, {
      ref: "modalSlotEmployees",
      onAssignEmployee: _ctx.assignEmployee,
      onUnassignEmployee: _ctx.unassignEmployee,
      byOrder: true
    }, null, 8, ["onAssignEmployee", "onUnassignEmployee"])
  ]))
})